import {
  Assessment,
  ComprehensiveAssessment,
  Event,
  Fixture,
  ICCReview,
  Org,
  Player,
  Team,
  Tournament,
  User,
  Venue,
} from 'src/api';
import { MainMenuOption } from 'src/service/MainMenu';

type LookupList = Map<number, string>;

export class AbstractUserRole {
  protected list: LookupList = new Map<number, string>();

  canSeeCompletedTournaments(): boolean {
    return false;
  }

  addToList(id: number | undefined, name: string | undefined) {
    if (id !== undefined && id > 0) this.list.set(id, name ?? String(id));
  }

  getList(): LookupList {
    return this.list;
  }

   
  canView(option: MainMenuOption): boolean {
    return false;
  }

  // unions
  canViewUnion(union: Org): boolean {
    return this.canEditUnion(union);
  }

   
  canEditUnion(union: Org): boolean {
    return false;
  }

  // teams
  canViewTeam(team: Team): boolean {
    return this.canEditTeam(team);
  }

   
  canEditTeam(team: Team): boolean {
    return false;
  }

  // players
  canViewPlayer(player: Player): boolean {
    return this.canEditPlayer(player);
  }

   
  canEditPlayer(player: Player): boolean {
    return false;
  }

  // events
  canCommentEvent(event: Event): boolean {
    return this.canEditEvent(event);
  }

  canEditEvent(event: Event): boolean {
    return !!event.player && this.canEditPlayer(event.player);
  }

   
  canReviewEvent(event: Event): boolean {
    return false;
  }

  canDownloadEventPdf(event: Event): boolean {
    return this.canViewPlayer(event.player ?? {});
  }

  // comprehensives
   
  canCreateComprehensiveAssessment(player: Player): boolean {
    return false;
  }

  canViewComprehensiveAssessment(assessment: ComprehensiveAssessment): boolean {
    return this.canCreateComprehensiveAssessment(assessment?.player ?? {});
  }

   
  canReviewComprehensiveAssessment(  assessment: ComprehensiveAssessment): boolean {
    return false;
  }

   
  canEditComprehensiveAssessment(assessment: ComprehensiveAssessment): boolean {
    return false;
  }

  // assessments
   
  canViewAssessment(assessment: Assessment): boolean {
    return this.canViewPlayer(
      assessment?.player ?? assessment?.event?.player ?? {},
    );
  }

  // users
  canViewUser(user: User): boolean {
    return this.canEditUser(user);
  }

   
  canEditUser(user: User): boolean {
    return false;
  }

  // tournaments
  canViewTournament(tournament: Tournament): boolean {
    return this.canEditTournament(tournament);
  }

   
  canEditTournament(tournament: Tournament): boolean {
    return false;
  }

  // venues
  canViewVenue(venue: Venue): boolean {
    return this.canEditVenue(venue);
  }

   
  canEditVenue(venue: Venue): boolean {
    return false;
  }

  // fixtures
   
  canAddFixture(tournament: Tournament | undefined): boolean {
    return false;
  }

  canViewFixture(fixture: Fixture): boolean {
    return this.canEditFixture(fixture);
  }

   
  canEditFixture(fixture: Fixture): boolean {
    return false;
  }

  canAddMDDToFixture(fixture: Fixture): boolean {
    return this.canEditFixture(fixture);
  }

  // icc reviews
  canViewICCReview(review: ICCReview): boolean {
    return this.canEditICCReview(review);
  }

   
  canEditICCReview(review: ICCReview): boolean {
    return false;
  }

  canToggleICCCompliance(): boolean {
    return false;
  }

  canIgnoreEvents(): boolean {
    return false;
  }
}
